import { filterStartYear, Role, ROLE_HIERARCHY, ROLES_LIST } from '../app.config';
import { SettingsDTO } from './types/settings';

export function initYears() {
  let years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= filterStartYear; i--) {
    years.push(i);
  }
  return years;
}


export function initMonths() {
  return [
    { value: 1, key: "COMMON.MONTHS.JANUARY" },
    { value: 2, key: "COMMON.MONTHS.FEBRUARY" },
    { value: 3, key: "COMMON.MONTHS.MARCH" },
    { value: 4, key: "COMMON.MONTHS.APRIL" },
    { value: 5, key: "COMMON.MONTHS.MAY" },
    { value: 6, key: "COMMON.MONTHS.JUNE" },
    { value: 7, key: "COMMON.MONTHS.JULY" },
    { value: 8, key: "COMMON.MONTHS.AUGUST" },
    { value: 9, key: "COMMON.MONTHS.SEPTEMBER" },
    { value: 10, key: "COMMON.MONTHS.OCTOBER" },
    { value: 11, key: "COMMON.MONTHS.NOVEMBER" },
    { value: 12, key: "COMMON.MONTHS.DECEMBER" }
  ];
}


export function initTimezones() {
  return [
    { label: 'COMMON.TIMEZONES.UTC_MINUS_12_00', value: 'Etc/GMT+12', offset: -12 },
    { label: 'COMMON.TIMEZONES.UTC_MINUS_11_00', value: 'Etc/GMT+11', offset: -11 },
    { label: 'COMMON.TIMEZONES.UTC_MINUS_10_00', value: 'Pacific/Honolulu', offset: -10 },
    { label: 'COMMON.TIMEZONES.UTC_MINUS_08_00', value: 'America/Los_Angeles', offset: -8 },
    { label: 'COMMON.TIMEZONES.UTC_MINUS_05_00', value: 'America/New_York', offset: -5 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_00_00', value: 'UTC', offset: 0 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_01_00', value: 'Europe/Budapest', offset: 1 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_02_00', value: 'Europe/Bucharest', offset: 2 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_03_00', value: 'Europe/Istanbul', offset: 3 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_05_30', value: 'Asia/Kolkata', offset: 5.5 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_08_00', value: 'Asia/Singapore', offset: 8 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_09_00', value: 'Asia/Tokyo', offset: 9 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_10_00', value: 'Australia/Sydney', offset: 10 },
    { label: 'COMMON.TIMEZONES.UTC_PLUS_12_00', value: 'Pacific/Auckland', offset: 12 }
  ];
}


export function onOrganisationChange(ownOrganisationsAndSites: any, selectedOrganisationId: any) {
  return ownOrganisationsAndSites
    .flatMap(item =>
      item.sites.map(site => ({
        ...site, organisationId: item.organisation.id
      })))
    .filter(site => site.organisationId === selectedOrganisationId);
}


export function getAssignableRoles(currentUserRole: Role | string) {
  const currentLevel = ROLE_HIERARCHY[currentUserRole as Role] || 0;
  return ROLES_LIST.filter(role => currentUserRole === 'REGIONAL_MANAGER'
    ? ROLE_HIERARCHY[role] < currentLevel
    : ROLE_HIERARCHY[role] <= currentLevel);
}


export function formatDateToISOString(date: Date): string {
  const pad = (num: number) => String(num).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
}


export function formatDateToHHmm(dateInput: Date | any, isSecondsNeeded: boolean = false): string {
  if (!dateInput) return null;

  const date = new Date(dateInput);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}` + (isSecondsNeeded ? `:${seconds}` : '');
}


export function isInOpeningHours(settingsData: SettingsDTO, time: any, isFormatNeeded: boolean = true): boolean {
  const currentTime = (isFormatNeeded ? formatDateToHHmm(time) : time);

  if (settingsData.closeIsOnSameDay) {
    return currentTime >= settingsData.openTime && currentTime <= settingsData.closeTime;
  } else {
    return currentTime >= settingsData.openTime || currentTime <= settingsData.closeTime;
  }
}
